module.exports = __webpack_public_path__ + "img/ArrowCircleDown.eb329a78.svg";